import styled  from 'styled-components';
import { Link } from 'react-router-dom';
import { ChevronRight } from "lucide-react"

const StyledComp = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  color: var(--grey);

  svg{
    margin: 0 5px;
  }
  .crumb, a{
    display:flex;
    flex-direction: row;
    align-items: center;
    color: var(--grey);
    font-size: 12px;
  }
  a:hover{
    text-decoration: underline;
  }
`;

const Comp = ({crumbs}) => {
  return (
  <StyledComp>
      {crumbs.map((c, i) => {
        return <div key={c.name} className="crumb">
            <Link to={c.path}>
            {c.name}
            {i !== (crumbs.length - 1)  &&
              <ChevronRight width={14}/>
            }
            </Link>
          </div>

      })}
  </StyledComp>
  );
};

export default Comp;
